module.exports = __webpack_public_path__ + "img/ic-wbdw-point.83a9e70e.png";